import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MedicationRouteNamePipe } from 'src/app/pipes/medication-route-name.pipe';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { MedicationRedLabelInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-medication-red-label-item',
    templateUrl: './medication-red-label-item.component.html',
    styleUrl: './medication-red-label-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent, MedicationRouteNamePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationRedLabelItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: MedicationRedLabelInstructions;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as MedicationRedLabelInstructions;
	}

	constructor() {
	}
}